import {Vue} from "vue-property-decorator";
//@ts-ignore
import numeral from 'numeral';
//@ts-ignore
import numFormat from 'vue-filter-number-format';

Vue.filter('numFormat', numFormat(numeral));
